// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"126":"04b29582","264":"c9490425"}[chunkId] + ".css";
};